import type { Currency, TaxSettings } from "@core/index";
import { useAppStore, scopeEntityId } from "@state/store";
import { SEED_SETTINGS } from "@data/index";

/**
 * Convenience accessor for the loaded ledger data plus the resolved scope.
 * Pages read from here rather than reaching into the store repeatedly.
 */
export function useLedger() {
  const status = useAppStore((s) => s.status);
  const error = useAppStore((s) => s.error);
  const entities = useAppStore((s) => s.entities);
  const accounts = useAppStore((s) => s.accounts);
  const entries = useAppStore((s) => s.entries);
  const settings: TaxSettings = useAppStore((s) => s.settings) ?? SEED_SETTINGS;
  const scope = useAppStore((s) => s.scope);
  const base: Currency = settings.baseCurrency;
  const entityId = scopeEntityId(scope);
  const scopeName =
    scope === "consolidated"
      ? "Consolidated group"
      : entities.find((e) => e.id === scope)?.name ?? scope;

  const postedCount = entries.filter(
    (e) => e.status === "posted" && (entityId === undefined || e.entityId === entityId),
  ).length;

  return {
    status,
    error,
    entities,
    accounts,
    entries,
    settings,
    scope,
    entityId,
    scopeName,
    base,
    postedCount,
    isEmpty: postedCount === 0,
  };
}
